(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32432],{

/***/ 57618:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/topic/[topicUid]/[conceptUid]",
      function () {
        return __webpack_require__(13868);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y8": function() { return /* binding */ fetchConstants; },
/* harmony export */   "iR": function() { return /* binding */ constantsAPIKey; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54051);



var defaultHost = (0,_utils_api_helper_host__WEBPACK_IMPORTED_MODULE_1__/* .getHost */ .XF)();
var constantsAPIKey = "v1/constants/?platform=0"; // pragma: allowlist secret
var fetchConstants = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", fetch("".concat(defaultHost).concat(constantsAPIKey)).then(function(res) {
                        return res.json();
                    }));
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchConstants() {
        return _ref.apply(this, arguments);
    };
}();
var fetchIsGoalGTP = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(goalUID, constantsData) {
        var constants, gtpGoalsList, isGTP;
        return _unacademy_web_learning_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = constantsData;
                    if (_ctx.t0) {
                        _ctx.next = 5;
                        break;
                    }
                    _ctx.next = 4;
                    return fetchConstants();
                case 4:
                    _ctx.t0 = _ctx.sent;
                case 5:
                    constants = _ctx.t0;
                    gtpGoalsList = constants.GTP_GOALS || [];
                    isGTP = gtpGoalsList === null || gtpGoalsList === void 0 ? void 0 : gtpGoalsList.includes(goalUID);
                    return _ctx.abrupt("return", isGTP);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchIsGoalGTP(goalUID, constantsData) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ __webpack_exports__["ZP"] = (fetchIsGoalGTP);


/***/ }),

/***/ 72830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getLevelDisplayInfo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);



var getLevelDisplayInfo = function() {
    return "v1/users/educator-levels-display-config/";
};
var useLevelDisplayInfo = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        selector: null,
        fallbackData: undefined
    };
    var key = getLevelDisplayInfo();
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(key, {}, {
        fallbackData: options.fallbackData
    }), levelsDisplayInfo = _ref.data, isValidating = _ref.isValidating, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref, [
        "data",
        "isValidating"
    ]);
    if (options.selector && typeof options.selector === "function") return options.selector(levelsDisplayInfo || []);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        key: key,
        levelsDisplayInfo: levelsDisplayInfo,
        isValidating: isValidating
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (useLevelDisplayInfo);


/***/ }),

/***/ 17562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23018);
/* harmony import */ var _icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93303);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2080);
/* harmony import */ var _P2_P2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72560);
/* harmony import */ var _Link_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76356);
/* harmony import */ var _IconButton_IconButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42531);









var BreadCrumb = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezseds00",
    label: "BreadCrumb"
})("border:1px solid var(--color-divider);");
var StyledCrumbs = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(BreadCrumb, {
    target: "ezseds01",
    label: "StyledCrumbs"
})("padding:", function(param) {
    var $padding = param.$padding;
    return $padding;
}, ";transform:skew(-20deg);height:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_8B */ .t8.B3, ";background-color:var(--color-base-1);margin:auto ", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_6 */ .t8.A1, ";cursor:pointer;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, ";@media only screen and (max-width:47.95em){display:none;}");
var Unskew = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_P2_P2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "ezseds02",
    label: "Unskew"
})("transform:skew(20deg);color:var(--color-text-primary);white-space:nowrap;text-overflow:ellipsis;max-width:280px;overflow:hidden;");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ezseds03",
    label: "Wrapper"
})("display:flex;-ms-overflow-style:none;scrollbar-width:none;overflow:auto;&::-webkit-scrollbar{display:none;}");
var BackButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "ezseds04",
    label: "BackButton"
})("margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_3B */ .t8.N, ";box-shadow:none;background-color:var(--color-base-1);");
var BreadCrumbs = function(param) {
    var tags = param.tags, className = param.className, onBackClick = param.onBackClick, useBackClick = param.useBackClick, padding = param.padding;
    var tagsLength = (tags === null || tags === void 0 ? void 0 : tags.length) || 0;
    var lastLink = tagsLength > 0 && !useBackClick ? tags === null || tags === void 0 ? void 0 : tags[tagsLength - 1] : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(Wrapper, {
        className: className,
        children: [
            lastLink ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: lastLink.href,
                as: lastLink.as,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BreadCrumb, {
                    as: BackButton,
                    bgColor: "var(--color-base-0)",
                    hovDisabled: true,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        size: _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM,
                        color: "var(--color-text-primary)"
                    })
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BreadCrumb, {
                as: BackButton,
                onClick: onBackClick,
                bgColor: "var(--color-base-0)",
                hovDisabled: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_icon_ArrowBack__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: _styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_4B */ .t8.BM,
                    color: "var(--color-text-primary)"
                })
            }),
            tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(StyledCrumbs, {
                    $padding: padding,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        href: tag.href,
                        as: tag.as,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(Unskew, {
                            children: tag.title
                        })
                    })
                }, tag.title);
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BreadCrumbs);
BreadCrumbs.propTypes = {
    padding: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    tags: prop_types__WEBPACK_IMPORTED_MODULE_8___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_8___default().shape({
        title: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired),
        as: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
        href: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string.isRequired)
    })),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    onBackClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().func),
    useBackClick: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().bool)
};
BreadCrumbs.defaultProps = {
    padding: "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_2B */ .t8.Rw, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_3__/* .Spacings.SPACING_5B */ .t8.zj),
    className: "",
    tags: [],
    onBackClick: _utils_breadcrumbs__WEBPACK_IMPORTED_MODULE_1__/* .goBack */ .Hm,
    useBackClick: false
};


/***/ }),

/***/ 88074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ InfiniteList_InfiniteList; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Base/CircularLoader/CircularLoader.jsx
var CircularLoader = __webpack_require__(13909);
// EXTERNAL MODULE: ./src/hooks/useInfiniteScrollHandler.js
var useInfiniteScrollHandler = __webpack_require__(7418);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/components/Skeletons/CourseCard/CourseCarousel.jsx + 1 modules
var CourseCarousel = __webpack_require__(10914);
;// CONCATENATED MODULE: ./src/components/Skeletons/index.js
/* eslint-disable import/prefer-default-export */ 

;// CONCATENATED MODULE: ./src/components/Composite/InfiniteList/InfiniteList.jsx



/* eslint-disable react/jsx-props-no-spreading */ /* eslint-disable react/prop-types */ /* eslint-disable react-hooks/exhaustive-deps */ 






var ProgressWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ecbt2ti0",
    label: "ProgressWrapper"
})("grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";width:484px;margin:auto;height:120px;display:flex;justify-content:center;align-items:center;@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){width:100%;grid-column:span 10;}");
var InfiniteList = function(props) {
    var onScrollEnd = function onScrollEnd() {
        if (data && !data.isFetching && isFetching) {
            if (data.next) {
                var loadPromise = loadMore();
                if (!loadPromise) return;
                loadPromise.then(function() {
                    setIsFetching(false);
                });
            } else {
                setIsFetching(false);
            }
        }
    };
    var ref;
    var data = props.data, _renderItem = props._renderItem, loadMore = props.loadMore, scrollElement = props.scrollElement, loaderType = props.loaderType, rowItems = props.rowItems, gridColumn = props.gridColumn, dataKey = props.dataKey, loaderColor = props.loaderColor, RenderItem = props.RenderItem, getItemKey = props.getItemKey, extraProps = props.extraProps;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useInfiniteScrollHandler/* default */.Z)(// eslint-disable-next-line no-use-before-define
    onScrollEnd, scrollElement), 2), isFetching = ref1[0], setIsFetching = ref1[1];
    react.useEffect(function() {
        setIsFetching(false);
    }, [
        dataKey
    ]);
    var getLoader = function() {
        if (loaderType === "course" || loaderType === "batchGroup") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCarousel/* default */.Z, {
                number: rowItems,
                gridColumn: gridColumn
            });
        }
        if (loaderType === "progress") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProgressWrapper, {
                gridColumn: gridColumn,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularLoader/* default */.Z, {
                    color: loaderColor
                })
            });
        }
    };
    if (!data) return null;
    var renderLoader = data.isFetching && loaderType !== "disabled";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            (ref = data.results) === null || ref === void 0 ? void 0 : ref.map(function(item, index) {
                if (RenderItem) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenderItem, (0,_object_spread/* default */.Z)({
                    item: item,
                    index: index
                }, extraProps), getItemKey(item, index));
                return _renderItem(item, index);
            }),
            renderLoader ? getLoader() : null
        ]
    });
};
InfiniteList.propTypes = {
    _renderItem: (prop_types_default()).func,
    RenderItem: (prop_types_default()).elementType,
    loadMore: (prop_types_default()).func,
    data: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    scrollElement: prop_types_default().objectOf((prop_types_default()).any),
    rowItems: (prop_types_default()).number,
    loaderType: prop_types_default().oneOf([
        "progress",
        "course",
        "disabled"
    ]),
    gridColumn: (prop_types_default()).string,
    dataKey: (prop_types_default()).string,
    loaderColor: (prop_types_default()).string,
    getItemKey: (prop_types_default()).func,
    extraProps: prop_types_default().objectOf((prop_types_default()).any)
};
InfiniteList.defaultProps = {
    loadMore: function() {
        return null;
    },
    scrollElement: null,
    loaderType: "progress",
    rowItems: 3,
    gridColumn: "span 10",
    dataKey: "",
    loaderColor: "var(--color-i-green)",
    getItemKey: function(_, index) {
        return index;
    },
    extraProps: {},
    _renderItem: function() {},
    RenderItem: null
};
/* harmony default export */ var InfiniteList_InfiniteList = (InfiniteList);


/***/ }),

/***/ 84852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80867);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _utils_isEmptyObject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9759);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);
/* harmony import */ var _api_hooks_profile_useLevelDisplayInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72830);
/* harmony import */ var _cont_MeDashboard_NextImageAvatar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72391);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88775);









// do we need to make different mapping for avatar size config
var avatarSizeConfig = {
    S: {
        totalWidth: "48px",
        avatarWidth: "40px",
        badgeWidth: "14px",
        avatarBorder: "2px solid var(--color-base-1)",
        badgeContainerPadding: "1.5px 0",
        badgePositionLeft: "30px"
    },
    M: {
        totalWidth: "80px",
        avatarWidth: "66.67px",
        badgeWidth: "20px",
        avatarBorder: "3px solid var(--color-base-1)",
        badgeContainerPadding: "2.5px 0",
        badgePositionLeft: "50px"
    },
    L: {
        totalWidth: "128px",
        avatarWidth: "106.67px",
        badgeWidth: "36px",
        avatarBorder: "4px solid var(--color-base-1)",
        badgeContainerPadding: "3px 0",
        badgePositionLeft: "80px"
    },
    XL: {
        totalWidth: "160px",
        avatarWidth: "133.33px",
        badgeWidth: "53.33px",
        avatarBorder: "5px solid var(--color-base-1)",
        badgeContainerPadding: "4px 0",
        badgePositionLeft: "113.33px"
    }
};
var platinumAvatarSizeConfig = {
    L: {
        totalWidth: "128px",
        avatarWidth: "128px",
        badgeWidth: "0px",
        avatarBorder: "4px solid var(--color-base-1)",
        badgeContainerPadding: "3px 0",
        badgePositionLeft: "80px"
    }
};
var Flex = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "epymaz30",
    label: "Flex"
})("display:flex;justify-content:center;align-items:center;");
var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(Flex, {
    target: "epymaz31",
    label: "Wrapper"
})("box-sizing:content-box;width:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";height:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";position:relative;padding:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].wrapperPadding;
}, ";border-radius:50%;flex:0 0 auto;background:", function(param) {
    var $badgeColor = param.$badgeColor;
    return "linear-gradient(rgba(255,255,255,0) 0 40%, ".concat($badgeColor, ")");
}, ";");
var PlatinumWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(Flex, {
    target: "epymaz32",
    label: "PlatinumWrapper"
})("box-sizing:content-box;width:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";height:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].totalWidth;
}, ";position:relative;padding:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].wrapperPadding;
}, ";flex:0 0 auto;border:1px solid var(--color-i-gray-v2);border-radius:8px;");
var BadgeContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "epymaz33",
    label: "BadgeContainer"
})("position:absolute;display:flex;left:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].badgePositionLeft;
}, ";bottom:0%;clip-path:polygon(0px 26%,51% 0px,100% 25%,100% 75%,50% 100%,0px 75%);background:", function(param) {
    var $badgeBgColor = param.$badgeBgColor;
    return $badgeBgColor || "var(--color-base-1)";
}, ";justify-content:center;align-items:center;padding:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].badgeContainerPadding;
}, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_2 */ .t8.Jl, ";");
var StyledAvatar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_cont_MeDashboard_NextImageAvatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "epymaz34",
    label: "StyledAvatar"
})("border:", function(param) {
    var $size = param.$size;
    return avatarSizeConfig[$size].avatarBorder;
}, ";");
var EducatorAvatar = function(param) {
    var size = param.size, src = param.src, levelInfo = param.levelInfo, isPlatinumEducator = param.isPlatinumEducator, badgeBgColor = param.badgeBgColor, isPartnerEducator = param.isPartnerEducator;
    var ref;
    var ref1 = (0,_api_hooks_profile_useLevelDisplayInfo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), _levelsDisplayInfo = ref1.levelsDisplayInfo, levelsDisplayInfo = _levelsDisplayInfo === void 0 ? [] : _levelsDisplayInfo;
    var currentLevelDisplayInfo = levelsDisplayInfo === null || levelsDisplayInfo === void 0 ? void 0 : (ref = levelsDisplayInfo.find) === null || ref === void 0 ? void 0 : ref.call(levelsDisplayInfo, function(levelDisplayInfo) {
        return levelDisplayInfo.levelId === ((levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.currentLevelId) || (levelInfo === null || levelInfo === void 0 ? void 0 : levelInfo.current_level_id));
    });
    currentLevelDisplayInfo = isPartnerEducator ? _constants__WEBPACK_IMPORTED_MODULE_5__/* .PARTNER_EDUCATOR_CONFIG */ .BB : currentLevelDisplayInfo;
    if (!isPlatinumEducator && !isPartnerEducator && ((0,_utils_isEmptyObject__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(levelInfo) || !currentLevelDisplayInfo)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_cont_MeDashboard_NextImageAvatar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            size: avatarSizeConfig[size].totalWidth,
            src: src
        });
    }
    var CurrentWrapper = isPlatinumEducator ? PlatinumWrapper : Wrapper;
    var CurrentAvatarConfig = avatarSizeConfig;
    if (isPlatinumEducator) {
        CurrentAvatarConfig.L = platinumAvatarSizeConfig.L;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsxs */ .BX)(CurrentWrapper, {
        $size: size,
        $badgeColor: currentLevelDisplayInfo === null || currentLevelDisplayInfo === void 0 ? void 0 : currentLevelDisplayInfo.color.primary,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(StyledAvatar, {
                size: CurrentAvatarConfig[size].avatarWidth,
                src: src,
                circular: !isPlatinumEducator,
                $size: size
            }),
            !isPlatinumEducator && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(BadgeContainer, {
                $size: size,
                $badgeBgColor: badgeBgColor,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__/* .jsx */ .tZ)(_base_Image__WEBPACK_IMPORTED_MODULE_0__["default"], {
                    src: currentLevelDisplayInfo === null || currentLevelDisplayInfo === void 0 ? void 0 : currentLevelDisplayInfo.asset.badge,
                    width: avatarSizeConfig[size].badgeWidth,
                    height: avatarSizeConfig[size].badgeWidth,
                    alt: "badge"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EducatorAvatar);
EducatorAvatar.propTypes = {
    size: prop_types__WEBPACK_IMPORTED_MODULE_8___default().oneOf([
        "S",
        "M",
        "L",
        "XL"
    ]).isRequired,
    src: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().string),
    levelInfo: prop_types__WEBPACK_IMPORTED_MODULE_8___default().shape((prop_types__WEBPACK_IMPORTED_MODULE_8___default().any))
};
EducatorAvatar.defaultProps = {
    src: "",
    levelInfo: {}
};


/***/ }),

/***/ 72391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);
/* harmony import */ var _base_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80867);








var StyledAvatar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Image__WEBPACK_IMPORTED_MODULE_2__["default"], {
    target: "e1j9ated0",
    label: "StyledAvatar"
})("border-radius:", function(param) {
    var $circular = param.$circular;
    return $circular ? "50%" : _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_2B */ .t8.Rw;
}, ";width:", function(param) {
    var size = param.size;
    return size;
}, ";height:", function(param) {
    var size = param.size;
    return size;
}, ";object-fit:cover;cursor:pointer;user-drag:none;user-select:none;");
var NextImageAvatar = function(props) {
    var src = props.src, className = props.className, circular = props.circular, size = props.size, alt = props.alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "src",
        "className",
        "circular",
        "size",
        "alt"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(StyledAvatar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, rest), {
        $circular: circular,
        src: src,
        className: className,
        height: size,
        width: size,
        decoding: "async",
        loading: "eager",
        alt: alt
    }));
};
NextImageAvatar.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string.isRequired),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    width: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    size: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string),
    circular: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().string)
};
NextImageAvatar.defaultProps = {
    height: "initial",
    width: "initial",
    size: null,
    className: "",
    circular: false,
    alt: "Avatar"
};
/* harmony default export */ __webpack_exports__["Z"] = (NextImageAvatar);


/***/ }),

/***/ 94411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51351);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);
/* harmony import */ var _material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84872);







var TooltipWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "e1q91hxr0",
    label: "TooltipWrapper"
})("background:var(--color-base-1);border:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_1 */ .t8.tF, " solid var(--color-divider);border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_1B */ .t8.MK, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_1B */ .t8.MK, ";");
var Text = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("p", {
    target: "e1q91hxr1",
    label: "Text"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.HEAVY */ .F3.XR, ";font-size:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Fonts.EXTRA_SMALL */ .F3.y2, ";line-height:100%;text-transform:uppercase;color:var(--color-text-primary);");
// eslint-disable-next-line no-empty-pattern
var TopicTooltip = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(param, ref) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle(ref, function() {
        return {
            onChapterHover: onChapterHover,
            onChapterLeave: onChapterLeave
        };
    });
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), open = _$ref[0], setOpen = _$ref[1];
    var _$ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(null), 2), hoveredItem = _$ref1[0], setHoveredItem = _$ref1[1];
    var onChapterLeave = function() {
        setHoveredItem(null);
        setOpen(false);
    };
    var onChapterHover = function(event, educatorCoveredConcept) {
        if (!educatorCoveredConcept) {
            setHoveredItem(event.currentTarget);
            setOpen(true);
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_material_ui_core_Popper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        open: open,
        anchorEl: hoveredItem,
        placement: "bottom-end",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TooltipWrapper, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(Text, {
                children: "Not covered by educator"
            })
        })
    });
});
TopicTooltip.displayName = "TopicTooltip";
/* harmony default export */ __webpack_exports__["Z"] = (TopicTooltip);


/***/ }),

/***/ 93496:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2080);

/* eslint-disable no-else-return */ 



var StyledCarousel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "eq1k4de0",
    label: "StyledCarousel"
})("display:grid;grid-template-columns:repeat(18,32px);grid-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_2__/* .Spacings.SPACING_4B */ .t8.BM, ";grid-column:span 18;@media only screen and (max-width:47.95em){grid-template-columns:repeat(10,1fr);grid-column:span 10;grid-column-gap:16px;grid-row-gap:16px;}");
var CourseCarousel = function(param) {
    var number = param.number, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledCarousel, {
        $number: number,
        children: children
    });
};
CourseCarousel.propTypes = {
    number: function number(props, propName, componentName) {
        if (typeof props[propName] !== "number") {
            return new Error("Invalid type of ".concat(propName, " supplied to ").concat(componentName, " Validation failed."));
        } else if (props[propName] > 3) {
            return new Error("Expected max value for ".concat(propName, " is 3 but supplied greater value to ").concat(componentName, " Validation failed."));
        }
    },
    children: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().node.isRequired)
};
CourseCarousel.defaultProps = {
    number: 3
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseCarousel);


/***/ }),

/***/ 10914:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CourseCard_CourseCarousel; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Skeletons/Carousel/Carousel.jsx
var Carousel = __webpack_require__(93496);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Skeleton/Skeleton.js
var Skeleton = __webpack_require__(58365);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/stores/selectors/darkModeStatusSelectors.js
var darkModeStatusSelectors = __webpack_require__(57054);
// EXTERNAL MODULE: ./src/stores/useDarkModeStatus.js
var useDarkModeStatus = __webpack_require__(3458);
;// CONCATENATED MODULE: ./src/components/Skeletons/CourseCard/CourseCard.jsx









var StyledPlusCourseCard = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wi5id40",
    label: "StyledPlusCourseCard"
})("background-color:var(--color-base-1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";overflow:hidden;grid-column:span 6;@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){grid-column:span 11;}");
var StyledSkeleton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Skeleton/* default */.Z, {
    target: "e1wi5id41",
    label: "StyledSkeleton"
})("@media only screen and (max-width:", styleConstants/* breakpoints.mobile */.AV.mobile, "){&.thumbnail{width:100% !important;}}", function(param) {
    var $isDarkModeOn = param.$isDarkModeOn;
    return $isDarkModeOn && "background-color: var(--color-base-1);";
});
var StyledPlusCourseCardDetails = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1wi5id42",
    label: "StyledPlusCourseCardDetails"
})("display:flex;flex-direction:column;justify-content:space-between;background-color:var(--color-base-1);text-align:left;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var CourseCard = function(param) {
    var className = param.className;
    var isDarkModeOn = (0,useDarkModeStatus/* default */.Z)(darkModeStatusSelectors/* getIsDarkModeOn */.q1);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPlusCourseCard, {
        className: className,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                variant: "rect",
                width: 272,
                height: 153,
                className: "thumbnail",
                $isDarkModeOn: isDarkModeOn
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPlusCourseCardDetails, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 22,
                        width: "20%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 20,
                        width: "100%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 20,
                        width: "30%",
                        style: {
                            marginBottom: 8
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 12,
                        width: "70%",
                        style: {
                            marginBottom: 16
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSkeleton, {
                        height: 18,
                        width: "40%"
                    })
                ]
            })
        ]
    });
};
CourseCard.propTypes = {
    className: (prop_types_default()).string
};
CourseCard.defaultProps = {
    className: ""
};
/* harmony default export */ var CourseCard_CourseCard = (CourseCard);

;// CONCATENATED MODULE: ./src/components/Skeletons/CourseCard/CourseCarousel.jsx




var CourseCarousel = function(param) {
    var number = param.number, gridColumn = param.gridColumn;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Carousel/* default */.Z, {
        number: number,
        gridColumn: gridColumn,
        children: new Array(number).fill(0).map(function(val, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCard_CourseCard, {}, String(index));
        })
    });
};
CourseCarousel.propTypes = {
    number: (prop_types_default()).number,
    gridColumn: (prop_types_default()).string
};
CourseCarousel.defaultProps = {
    number: 3,
    gridColumn: "span 18"
};
/* harmony default export */ var CourseCard_CourseCarousel = (CourseCarousel);


/***/ }),

/***/ 6858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable react-hooks/exhaustive-deps */ 
var useFirstRenderSkip = function(callback, deps) {
    var isFirstRenderingDone = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (isFirstRenderingDone.current) callback();
        else isFirstRenderingDone.current = true;
    }, deps);
};
/* harmony default export */ __webpack_exports__["Z"] = (useFirstRenderSkip);


/***/ }),

/***/ 7418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var detect_it__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43295);
/* eslint-disable react-hooks/exhaustive-deps */ 

var useInfiniteScroll = function(callback, scrollElement) {
    var handleScroll = function handleScroll() {
        var pageHeight = getPageHeight();
        var windowHeight = getWindowHeight();
        var scrollPosition = getScrollPosition();
        if (pageHeight - 350 <= windowHeight + scrollPosition) {
            if (!isFetching) setIsFetching(true);
        }
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFetching = ref[0], setIsFetching = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), fetchedExtra = ref1[0], setFetchedExtra = ref1[1];
    var getPageHeight = function() {
        return (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollHeight) || document.documentElement.offsetHeight;
    };
    var getWindowHeight = function() {
        return (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.offsetHeight) || window.innerHeight;
    };
    var getScrollPosition = function() {
        return (scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.scrollTop) || window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var pageHeight = getPageHeight();
        var windowHeight = getWindowHeight();
        var scrollPosition = getScrollPosition();
        // Check if the height of the window or scrollElement is not scrollable due to the pageHeight being less than or equal to the window height.
        if (scrollPosition === 0 && windowHeight >= pageHeight && !fetchedExtra) {
            // Load some data to fill some extra info to populate till scroll.
            setFetchedExtra(true); // To ensure that in case there is no data due to which the screen is blank, there isn't an infinite API call sequence.
            setTimeout(function() {
                setIsFetching(true);
            }, 1000);
        }
        if (scrollElement) {
            scrollElement.addEventListener("scroll", handleScroll, detect_it__WEBPACK_IMPORTED_MODULE_1__/* ["default"].passiveEvents */ .Z.passiveEvents === true ? {
                capture: false,
                passive: true
            } : false);
            return function() {
                return scrollElement.removeEventListener("scroll", handleScroll);
            };
        }
        window.addEventListener("scroll", handleScroll, detect_it__WEBPACK_IMPORTED_MODULE_1__/* ["default"].passiveEvents */ .Z.passiveEvents === true ? {
            capture: false,
            passive: true
        } : false);
        return function() {
            return window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isFetching) return;
        var timeout = setTimeout(callback, 100);
        return function() {
            return clearTimeout(timeout);
        };
    }, [
        isFetching
    ]);
    return [
        isFetching,
        setIsFetching
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useInfiniteScroll);


/***/ }),

/***/ 13868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _conceptUid_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/seo/index.jsx + 2 modules
var seo = __webpack_require__(14432);
// EXTERNAL MODULE: ./src/redux/actions/topologies.js
var topologies = __webpack_require__(62282);
// EXTERNAL MODULE: ./src/redux/actions/courses.js
var courses = __webpack_require__(5861);
// EXTERNAL MODULE: ./src/stores/sidenav.js
var sidenav = __webpack_require__(19204);
// EXTERNAL MODULE: ./src/seo/topic/topic.js
var topic = __webpack_require__(89765);
// EXTERNAL MODULE: ./src/redux/selectors/topologies.js
var selectors_topologies = __webpack_require__(83109);
// EXTERNAL MODULE: ./src/redux/selectors/auth.js
var auth = __webpack_require__(34497);
// EXTERNAL MODULE: ./src/components/Container/PlusCourses/syllabusHelper.js
var syllabusHelper = __webpack_require__(57705);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./src/hooks/useFetch.js
var useFetch = __webpack_require__(68826);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./src/components/Base/H4/H4.jsx
var H4 = __webpack_require__(64250);
// EXTERNAL MODULE: ./src/redux/selectors/syllabus.js + 1 modules
var syllabus = __webpack_require__(10448);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/redux/actions/practiceSession.js
var practiceSession = __webpack_require__(70261);
// EXTERNAL MODULE: ./src/components/Container/PlusCourses/MoreCourses.jsx
var MoreCourses = __webpack_require__(51273);
// EXTERNAL MODULE: ./src/redux/selectors/subscription.js
var subscription = __webpack_require__(83553);
// EXTERNAL MODULE: ./src/utils/pushRoute.js
var pushRoute = __webpack_require__(751);
// EXTERNAL MODULE: ./src/stores/AppCommonData.jsx + 1 modules
var AppCommonData = __webpack_require__(83995);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/utils/route.js
var route = __webpack_require__(56217);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/hooks/useEnroll.js
var useEnroll = __webpack_require__(76628);
// EXTERNAL MODULE: ./src/components/Composite/Dialog/Dialog.tsx + 1 modules
var Dialog = __webpack_require__(76920);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/components/Container/PlusCourses/PlusCard.jsx
var PlusCard = __webpack_require__(19867);
// EXTERNAL MODULE: ./src/components/Base/Grow/Grow.jsx
var Grow = __webpack_require__(5010);
// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./src/components/Base/P1/P1.jsx
var P1 = __webpack_require__(85620);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/hooks/useIsRecordedGoal.js
var useIsRecordedGoal = __webpack_require__(23207);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/TopicPage/enrollments/EnrolledCourses.tsx






















var Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1h4tdv00",
    label: "Wrapper"
})("margin-top:", styleConstants/* Spacings.SPACING_20B */.t8.Ay, ";");
var BlockWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1h4tdv01",
    label: "BlockWrapper"
})("grid-column:span 24;display:grid;grid-template-columns:repeat(24,1fr);grid-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{grid-template-columns:repeat(1,1fr);}");
var BoldP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1h4tdv02",
    label: "BoldP1"
})("font-weight:", styleConstants/* Fonts.BOLD */.F3.Pl, ";line-height:14px;");
var LabelDiv = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1h4tdv03",
    label: "LabelDiv"
})("grid-column:span 18;display:flex;margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";align-items:center;");
var SeeAllLink = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1h4tdv04",
    label: "SeeAllLink"
})(styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{display:none;}");
var imageBorderRadius = "".concat(styleConstants/* Spacings.SPACING_2B */.t8.Rw, " ").concat(styleConstants/* Spacings.SPACING_0B */.t8.NE, " ").concat(styleConstants/* Spacings.SPACING_0B */.t8.NE, " ").concat(styleConstants/* Spacings.SPACING_2B */.t8.Rw);
var EnrolledCourses = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var topic = param.topic;
    var feedBlock = (0,es/* useSelector */.v9)(function(state) {
        return (0,syllabus/* getEnrolledCoursesFeed */.Lg)(state, topic.uid);
    });
    var query = (0,router.useRouter)().query;
    var goalSlug = query.goalSlug, goalUID = query.goalUID, topicGroupUID = query.topicUid;
    var isRecordedGoal = (0,useIsRecordedGoal/* default */.Z)(goalUID);
    var _$ref = (0,useEnroll/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, syllabusHelper/* enrollProps */.g), {
        isRecordedGoal: isRecordedGoal
    })), isUnEnrollModalOpen = _$ref.isUnEnrollModalOpen, toggleEnroll = _$ref.toggleEnroll, acceptOnClick = _$ref.acceptOnClick, onCloseModal = _$ref.onCloseModal;
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    if (!feedBlock.results.length) return null;
    var renderBlock = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: feedBlock.results.slice(0, 4).map(function(courseData, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusCard/* default */.Z, {
                    courseData: courseData,
                    toggleEnroll: toggleEnroll,
                    index: index,
                    imageBorderRadius: imageBorderRadius,
                    showProgress: true,
                    orientation: "vertical",
                    gridColumn: "span 6"
                }, courseData.course);
            })
        });
    };
    var seeAllClick = function() {
        analytics/* segment.track */.EX.track(segment/* SYLLABUS_SEE_ALL_CLICKED */.fGQ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            last_primary_source: segment/* TOPIC_SYLLABUS_PAGE */.zyj,
            last_primary_source_section: "Topic Page - Enrolments"
        }), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY, true);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LabelDiv, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H4/* default */.Z, {
                        children: "Enrollments"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grow/* default */.Z, {}),
                    feedBlock.results.length > 4 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeeAllLink, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* default */.Z, {
                            href: {
                                pathname: "/goal/".concat(goalSlug, "/").concat(goalUID, "/enrolled"),
                                query: {
                                    topicGroupUID: topicGroupUID
                                }
                            },
                            onClick: seeAllClick,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BoldP1, {
                                color: "var(--color-i-green)",
                                children: "SEE ALL"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlockWrapper, {
                children: renderBlock()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog["default"], {
                onClose: onCloseModal,
                dialogState: isUnEnrollModalOpen,
                heading: "Are you sure you want to unenroll?",
                message: constants/* staticStrings.UNENROLL_MESSAGE */.Bc.UNENROLL_MESSAGE,
                acceptLabel: "Unenroll",
                rejectLabel: "Cancel",
                acceptOnClick: acceptOnClick,
                rejectOnClick: onCloseModal
            })
        ]
    });
});
EnrolledCourses.displayName = "EnrolledCourses";
/* harmony default export */ var enrollments_EnrolledCourses = (EnrolledCourses);

// EXTERNAL MODULE: ./src/components/Container/Syllabus/TopicPage/NotesCard.tsx + 1 modules
var NotesCard = __webpack_require__(65991);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/TopicPage/chapterInfo/ChapterInfo.tsx + 7 modules
var ChapterInfo = __webpack_require__(19396);
// EXTERNAL MODULE: ./src/components/Base/H5/H5.jsx
var H5 = __webpack_require__(43807);
// EXTERNAL MODULE: ./src/utils/boxShadowGenerator.js
var boxShadowGenerator = __webpack_require__(87312);
// EXTERNAL MODULE: ./src/stores/selectors/darkModeStatusSelectors.js
var darkModeStatusSelectors = __webpack_require__(57054);
// EXTERNAL MODULE: ./src/stores/useDarkModeStatus.js
var useDarkModeStatus = __webpack_require__(3458);
// EXTERNAL MODULE: ./src/api/selectors/constants.js
var selectors_constants = __webpack_require__(17064);
// EXTERNAL MODULE: ./src/api/hooks/useConstants.js
var useConstants = __webpack_require__(79917);
// EXTERNAL MODULE: ./src/components/Container/Syllabus/CommonCards/TopicTooltip.tsx
var TopicTooltip = __webpack_require__(94411);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/TopicPage/SideNav.tsx


















var maxNoOfChapters = 8;
var maxHeight = maxNoOfChapters * 18 + maxNoOfChapters * 16;
var SideNav_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1ww3lmt0",
    label: "Wrapper"
})("position:relative;");
var InnerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1ww3lmt1",
    label: "InnerWrapper"
})("position:sticky;top:200px;margin-top:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";");
var ChaptersList = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1ww3lmt2",
    label: "ChaptersList"
})("max-height:", maxHeight, "px;overflow-y:scroll;overflow-x:hidden;display:grid;margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";padding-left:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";&::-webkit-scrollbar{background-color:transparent;width:0px;}&:hover{&::-webkit-scrollbar{width:8px;}&::-webkit-scrollbar-thumb{border-radius:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";background-color:var(--color-text-secondary);}}");
var StyP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1ww3lmt3",
    label: "StyP1"
})("line-height:18px;margin-bottom:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";max-width:195px;text-overflow:ellipsis;cursor:", function(param) {
    var $cursor = param.$cursor;
    return $cursor;
}, ";overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;line-clamp:2;-webkit-box-orient:vertical;font-weight:", function(param) {
    var $fontWeight = param.$fontWeight;
    return $fontWeight;
}, ";");
var StyH4 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H4/* default */.Z, {
    target: "e1ww3lmt4",
    label: "StyH4"
})("line-height:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";font-weight:600;padding-left:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";");
var StyH5 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H5/* default */.Z, {
    target: "e1ww3lmt5",
    label: "StyH5"
})("cursor:pointer;");
var StyleH5 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H5/* default */.Z, {
    target: "e1ww3lmt6",
    label: "StyleH5"
})("cursor:pointer;margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";padding-left:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";");
var CoursesWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1ww3lmt7",
    label: "CoursesWrapper"
})("height:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";background:var(--color-base-0);display:flex;align-items:center;padding-left:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";margin-right:43px;box-shadow:", function(param) {
    var color = param.color;
    return (0,boxShadowGenerator/* default */.Z)({
        yOffset: "-16px",
        color: color
    });
}, ";");
var TooltipWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1ww3lmt8",
    label: "TooltipWrapper"
})("background:var(--color-base-1);border:", styleConstants/* Spacings.SPACING_1 */.t8.tF, " solid var(--color-i-gray-v2);border-radius:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";padding:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";");
var Text = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("p", {
    target: "e1ww3lmt9",
    label: "Text"
})("font-weight:", styleConstants/* Fonts.HEAVY */.F3.XR, ";font-size:", styleConstants/* Fonts.EXTRA_SMALL */.F3.y2, ";line-height:100%;text-transform:uppercase;color:var(--color-text-primary);");
var StyPopper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(TopicTooltip/* default */.Z, {
    target: "e1ww3lmt10",
    label: "StyPopper"
})("margin-top:10.5px;");
var SideNav = function(param) {
    var chaptersList = param.chaptersList, goalUID = param.goalUID, areMoreCoursesAvailable = param.areMoreCoursesAvailable, scrollToCourses = param.scrollToCourses, scrollToChapter = param.scrollToChapter, isSyllabusPageEducatorSpecific = param.isSyllabusPageEducatorSpecific;
    var isDarkModeOn = (0,useDarkModeStatus/* default */.Z)(darkModeStatusSelectors/* getIsDarkModeOn */.q1);
    var isGTP = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsGTPGoal */.vf)(goalUID));
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var popupRef = react.useRef();
    var ref = (0,react.useState)(-1), selectedItem = ref[0], setSelectedItem = ref[1];
    var onChapterLeave = function() {
        popupRef.current.onChapterLeave();
    };
    var onChapterHover = function(educatorCoveredTopic) {
        return function(event) {
            popupRef.current.onChapterHover(event, educatorCoveredTopic);
        };
    };
    var renderCoursesNavItem = function() {
        if (chaptersList.length <= maxNoOfChapters) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyleH5, {
                onClick: scrollToCourses,
                children: "Courses"
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CoursesWrapper, {
            color: isDarkModeOn ? "rgba(66, 66, 68, 0.2)" : "rgba(233, 238, 242, 0.4)",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH5, {
                onClick: scrollToCourses,
                children: "Courses"
            })
        });
    };
    var onChapterClick = function(index, educatorCoveredConcept) {
        return function() {
            if (educatorCoveredConcept) {
                setSelectedItem(index);
                scrollToChapter(index);
                setTimeout(function() {
                    setSelectedItem(-1);
                }, 2000);
                var conceptData = chaptersList[index];
                analytics/* segment.track */.EX.track(segment/* SYLLABUS_MENU_CLICKED */.Zl0, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
                    topology_uid: conceptData.uid,
                    topology_name: conceptData.title,
                    topology_level: 20
                }));
            }
        };
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SideNav_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH4, {
                                children: isGTP ? "Concepts" : "Chapters"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChaptersList, {
                                children: chaptersList.map(function(chapter, index) {
                                    var ref = chapter || {}, uid = ref.uid, title = ref.title, _educatorCoveredConcept = ref.educatorCoveredConcept, educatorCoveredConcept = _educatorCoveredConcept === void 0 ? true : _educatorCoveredConcept;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyP1, {
                                        color: "var(--color-text-primary)",
                                        onClick: onChapterClick(index, educatorCoveredConcept),
                                        onMouseEnter: onChapterHover(educatorCoveredConcept),
                                        onMouseLeave: onChapterLeave,
                                        $fontWeight: selectedItem === index ? styleConstants/* Fonts.SEMIBOLD */.F3.rX : styleConstants/* Fonts.LIGHT */.F3.rp,
                                        $cursor: educatorCoveredConcept ? "pointer" : "default",
                                        children: title
                                    }, uid);
                                })
                            })
                        ]
                    }),
                    areMoreCoursesAvailable && !isSyllabusPageEducatorSpecific && renderCoursesNavItem()
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyPopper, {
                ref: popupRef
            })
        ]
    });
};
/* harmony default export */ var TopicPage_SideNav = (SideNav);

// EXTERNAL MODULE: ./src/components/Container/Syllabus/constants/apiHelper.js
var apiHelper = __webpack_require__(58869);
// EXTERNAL MODULE: ./src/components/Base/Paper/Paper.jsx
var Paper = __webpack_require__(59485);
// EXTERNAL MODULE: ./src/components/Base/BreadCrumbs/BreadCrumbs.jsx
var BreadCrumbs = __webpack_require__(17562);
// EXTERNAL MODULE: ./src/utils/breadcrumbs.js
var breadcrumbs = __webpack_require__(23018);
// EXTERNAL MODULE: ./src/components/Base/H2/H2.jsx
var H2 = __webpack_require__(39396);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/components/Container/EducatorProfile/EducatorAvatar.jsx
var EducatorAvatar = __webpack_require__(84852);
// EXTERNAL MODULE: ./src/api/hooks/utils.js
var utils = __webpack_require__(61059);
// EXTERNAL MODULE: ./src/constants/empty.js
var empty = __webpack_require__(59375);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/utils/index.ts
var getIsSyllabusPageEducatorSpecific = function(educatorUID, author) {
    return !!educatorUID && author && !!author.firstName;
};
var getIsChapterMissing = function(chapters) {
    return chapters.some(function(chapter) {
        return !chapter.educatorCoveredConcept;
    });
};

// EXTERNAL MODULE: ./src/components/Container/Syllabus/constants/getTopicGroupAssetObj.js
var getTopicGroupAssetObj = __webpack_require__(77608);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/TopicPage/Header.tsx
























var HeaderNavBar = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Paper/* default */.Z, {
    target: "e1qg89fn0",
    label: "HeaderNavBar"
})("margin-bottom:", function(param) {
    var // @ts-ignore
    $margin = param.$margin;
    return $margin;
}, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";padding:", styleConstants/* Spacings.SPACING_8B */.t8.B3, " ", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";position:sticky;z-index:1;top:0;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{background:var(--color-base-0);box-shadow:none;padding:", styleConstants/* Spacings.SPACING_6B */.t8.BY, " 0 0 0;margin-bottom:", styleConstants/* Spacings.SPACING_8B */.t8.B3, ";}");
var TitleWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qg89fn1",
    label: "TitleWrapper"
})("display:flex;align-items:center;margin-top:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H2/* default */.Z, {
    target: "e1qg89fn2",
    label: "Title"
})("font-weight:", styleConstants/* Fonts.BOLD */.F3.Pl, ";height:", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";line-height:150%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{height:auto;}");
var Header_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1qg89fn3",
    label: "Wrapper"
})("margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var StyledP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1qg89fn4",
    label: "StyledP1"
})("color:var(--color-text-secondary);");
var Header = function(param) {
    var goalUID = param.goalUID, title = param.title, addMargin = param.addMargin, topicGroupTitle = param.topicGroupTitle, author = param.author;
    var ref = (0,router.useRouter)(), _query = ref.query, educatorUID = _query.educatorUID, educatorUsername = _query.educatorUsername;
    var isSyllabusPageEducatorSpecific = getIsSyllabusPageEducatorSpecific(educatorUID, author);
    var isRecordedGoal = (0,useIsRecordedGoal/* default */.Z)(goalUID);
    var getHeaderTags = (0,react.useCallback)(function(goalTopology, isGTP, isOfflineSubscription) {
        var tags = [];
        if (goalTopology) {
            var _tags;
            tags = (_tags = tags).concat.apply(_tags, (0,_to_consumable_array/* default */.Z)(breadcrumbs/* default.getPlusTopicsTags */.ZP.getPlusTopicsTags(goalTopology, isOfflineSubscription)));
            if (isSyllabusPageEducatorSpecific) {
                var _tags1;
                tags = (_tags1 = tags).concat.apply(_tags1, (0,_to_consumable_array/* default */.Z)(breadcrumbs/* default.getEducatorTag */.ZP.getEducatorTag(author, educatorUsername)));
            } else {
                var _tags2;
                tags = (_tags2 = tags).concat.apply(_tags2, (0,_to_consumable_array/* default */.Z)(breadcrumbs/* default.getTopics */.ZP.getTopics(goalTopology, isGTP)));
            }
        }
        return tags;
    }, [
        author,
        educatorUsername,
        isSyllabusPageEducatorSpecific
    ]);
    var goalTopology = (0,es/* useSelector */.v9)(function(state) {
        return(// @ts-ignore
        (0,syllabus/* getGoalInfoForCoursesPage */.eU)(state, goalUID));
    });
    var isGTP = (0,useConstants/* default */.Z)((0,selectors_constants/* getIsGTPGoal */.vf)(goalUID));
    var ref1 = (0,router.useRouter)(), goalSlug = ref1.query.goalSlug;
    var icon = (0,getTopicGroupAssetObj/* default */.Z)(topicGroupTitle).icon;
    var goBack = function() {
        if (isSyllabusPageEducatorSpecific) (0,pushRoute/* default */.Z)("/[authorID]", "/@".concat(educatorUsername));
        else (0,pushRoute/* default */.Z)("/goal/[goalSlug]/[goalUID]/topics", "/goal/".concat(goalSlug, "/").concat(goalUID, "/topics"));
    };
    var ref2 = author || empty/* emptyObject */.FD, _levelInfo = ref2.levelInfo, levelInfo = _levelInfo === void 0 ? {} : _levelInfo, thumbnail = ref2.avatar, firstName = ref2.firstName, lastName = ref2.lastName;
    var isOfflineSubscription = (0,es/* useSelector */.v9)((0,subscription/* getIsSubscribedToOffline */.ZB)(goalUID));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(HeaderNavBar, {
            // @ts-ignore
            $margin: addMargin ? styleConstants/* Spacings.SPACING_10B */.t8.FC : "",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BreadCrumbs/* default */.Z, {
                    tags: getHeaderTags(goalTopology, isGTP || isRecordedGoal, isOfflineSubscription),
                    onBackClick: goBack,
                    useBackClick: true
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TitleWrapper, {
                    children: [
                        isSyllabusPageEducatorSpecific ? // @ts-ignore
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorAvatar/* default */.Z, {
                            size: "M",
                            levelInfo: levelInfo,
                            src: thumbnail
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                            height: styleConstants/* Spacings.SPACING_10B */.t8.FC,
                            width: styleConstants/* Spacings.SPACING_10B */.t8.FC,
                            alt: "syllabus-subject-icon",
                            src: icon
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Header_Wrapper, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                    "data-testid": "topic-title",
                                    children: title
                                }),
                                isSyllabusPageEducatorSpecific && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledP1, {
                                    "data-testid": "educator-name",
                                    children: [
                                        "By ",
                                        (0,utils/* getFullName */.P)(firstName, lastName)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var TopicPage_Header = (Header);

// EXTERNAL MODULE: ./src/components/Base/H3/H3.jsx
var H3 = __webpack_require__(82034);
// EXTERNAL MODULE: ./src/components/Base/P2/P2.jsx
var P2 = __webpack_require__(72560);
// EXTERNAL MODULE: ./src/components/Base/Button/Button.jsx
var Button = __webpack_require__(35415);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/TopicPage/PreSubscriptionBanner.tsx










var PreSubscriptionBanner_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eop1c4e0",
    label: "Wrapper"
})("padding:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";background:rgb(8,189,128,0.1);border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";display:flex;margin-bottom:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";align-items:center;");
var InfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eop1c4e1",
    label: "InfoWrapper"
})("margin-left:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-right:", styleConstants/* Spacings.SPACING_23B */.t8.He, ";");
var PreSubscriptionBanner_StyP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "eop1c4e2",
    label: "StyP1"
})("width:342px;line-height:", styleConstants/* Spacings.SPACING_5B */.t8.zj, ";margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";color:var(--color-text-secondary);");
var StyP2 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P2/* default */.Z, {
    target: "eop1c4e3",
    label: "StyP2"
})("margin-top:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";line-height:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";");
var StyH3 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H3/* default */.Z, {
    target: "eop1c4e4",
    label: "StyH3"
})("line-height:", styleConstants/* Spacings.SPACING_7B */.t8.d5, ";");
var PreSubscriptionBanner = function(param) {
    var title = param.title, description = param.description, handleButtonClick = param.handleButtonClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PreSubscriptionBanner_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                src: "syllabus/plus-icon_new.svg",
                width: "50px",
                height: "52px",
                alt: "plusicon"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyH3, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PreSubscriptionBanner_StyP1, {
                        color: "var(--color-i-gray)",
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                // @ts-ignore
                label: "Get subscription",
                onClick: handleButtonClick
            })
        ]
    });
};
/* harmony default export */ var TopicPage_PreSubscriptionBanner = (PreSubscriptionBanner);

// EXTERNAL MODULE: ./src/components/Container/EducatorProfile/constants.jsx
var EducatorProfile_constants = __webpack_require__(88775);
;// CONCATENATED MODULE: ./src/components/Container/Syllabus/TopicPage/MissingChaptersNudge.tsx
















var MissingChaptersNudge_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ew1k7el0",
    label: "Wrapper"
})("background-color:var(--color-base-1);margin-top:", styleConstants/* Spacings.SPACING_20B */.t8.Ay, ";padding-top:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";border-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";box-shadow:", (0,boxShadowGenerator/* default */.Z)(), ";display:flex;align-items:center;justify-content:space-between;");
var MissingChaptersNudge_InfoWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "ew1k7el1",
    label: "InfoWrapper"
})("padding:", styleConstants/* Spacings.SPACING_5B */.t8.zj, " 0 ", styleConstants/* Spacings.SPACING_8B */.t8.B3, " ", styleConstants/* Spacings.SPACING_12B */.t8.SL, ";");
var MissingChaptersNudge_StyH4 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H4/* default */.Z, {
    target: "ew1k7el2",
    label: "StyH4"
})("font-weight:", styleConstants/* Fonts.SEMIBOLD */.F3.rX, ";line-height:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";");
var MissingChaptersNudge_StyP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "ew1k7el3",
    label: "StyP1"
})("font-weight:", styleConstants/* Fonts.LIGHT */.F3.rp, ";line-height:18px;margin-top:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var StyButton = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Button/* default */.Z, {
    target: "ew1k7el4",
    label: "StyButton"
})("margin-top:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";font-size:", styleConstants/* Fonts.ULTRA_SMALL */.F3.tN, ";line-height:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";font-weight:", styleConstants/* Fonts.HEAVY */.F3.XR, ";");
var MissingChaptersNudge = function(param) {
    var _meta = param.meta, meta = _meta === void 0 ? {} : _meta;
    var query = (0,router.useRouter)().query;
    var topicUid = query.topicUid, conceptUid = query.conceptUid, goalUID = query.goalUID, goalSlug = query.goalSlug;
    var ctaText = meta.ctaText, title = meta.title, description = meta.description;
    // @ts-ignore
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        goalUID: goalUID
    });
    var redirectToSyllabusPage = function() {
        analytics/* segment.track */.EX.track(EducatorProfile_constants/* BANNER_CLICKED */.YD, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData), {
            banner_title: "Educator Library",
            banner_type: "Introduction"
        }));
        (0,pushRoute/* default */.Z)("/goal/[goalSlug]/[goalUID]/topic/[topicUid]/[conceptUid]", "/goal/".concat(goalSlug, "/").concat(goalUID, "/topic/").concat(topicUid, "/").concat(conceptUid));
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MissingChaptersNudge_Wrapper, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MissingChaptersNudge_InfoWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MissingChaptersNudge_StyH4, {
                        color: "var(--color-text-primary)",
                        children: title
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MissingChaptersNudge_StyP1, {
                        color: "var(--color-text-secondary)",
                        children: description
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyButton, {
                        // @ts-ignore
                        label: ctaText,
                        variant: "filled",
                        color: "black",
                        maxHeight: "xs",
                        width: "157px",
                        onClick: redirectToSyllabusPage
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                src: "syllabus/missing-chapter-image.png",
                alt: "syllabus-missing-chapter-image",
                height: "150px",
                width: "100px"
            })
        ]
    });
};
/* harmony default export */ var TopicPage_MissingChaptersNudge = (MissingChaptersNudge);

;// CONCATENATED MODULE: ./src/components/Container/Syllabus/TopicPage/TopicPage.tsx



/* eslint-disable import/no-cycle */ 


























var TopicPage_Wrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e7z9qkn0",
    label: "Wrapper"
})("grid-column:inherit;pointer-events:", function(param) {
    var // @ts-ignore
    disabled = param.disabled;
    return disabled ? "none" : "auto";
}, ";");
var ChaptersInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e7z9qkn1",
    label: "ChaptersInfo"
})("display:grid;grid-template-columns:1.7fr 4fr;column-gap:", styleConstants/* Spacings.SPACING_16B */.t8.hN, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{grid-template-columns:4fr;}");
var TopicPage_BlockWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e7z9qkn2",
    label: "BlockWrapper"
})("grid-column:span 24;display:grid;grid-template-columns:repeat(24,1fr);grid-gap:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_14B */.t8.zJ, ";");
var MoreCoursesWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(TopicPage_BlockWrapper, {
    target: "e7z9qkn3",
    label: "MoreCoursesWrapper"
})("margin-top:", styleConstants/* Spacings.SPACING_20B */.t8.Ay, ";", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{grid-template-columns:repeat(10,1fr);grid-column-gap:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";grid-row-gap:0;grid-column:span 10;position:relative;& > div[orientation='vertical']{margin-bottom:", styleConstants/* Spacings.SPACING_6B */.t8.BY, ";}}");
var TopicPage_Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H4/* default */.Z, {
    target: "e7z9qkn4",
    label: "Title"
})("color:var(--color-text-primary);margin-bottom:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";padding:0;grid-column:span 18;", styleConstants/* mediaQuery.uptoMobile */.cy.uptoMobile, "{margin-bottom:0;grid-column:span 10;}");
var ChaptersWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e7z9qkn5",
    label: "ChaptersWrapper"
})("margin-bottom:", styleConstants/* Spacings.SPACING_20B */.t8.Ay, ";&:last-child{margin-bottom:0;}");
var Concepts = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e7z9qkn6",
    label: "Concepts"
})("margin-top:", styleConstants/* Spacings.SPACING_10B */.t8.FC, ";");
var CHAPTERS_WRAPPER_MARGIN_BOTTOM = 80;
var HEADER_HEIGHT = 120;
var MORE_COURSES_MARGIN_TOP = 80;
var TopicPage = function(param) {
    var goalUID = param.goalUID, goalSlug = param.goalSlug, topicUID = param.topicUID;
    var query = (0,router.useRouter)().query;
    var educatorUID = query.educatorUID;
    var coursesRef = react.useRef(null);
    var chaptersRef = react.useRef(null);
    var endpoint = (0,apiHelper/* getTopicInfoEndpoint */.PC)(goalUID, topicUID, educatorUID);
    var ref = (0,useFetch/* default */.Z)(endpoint, {}, {
        revalidateOnMount: false
    }), _data = ref.data, data = _data === void 0 ? {} : _data, isError = ref.isError;
    var tmp = data.data, topicInfo = tmp === void 0 ? {} : tmp, _meta = data.meta, meta = _meta === void 0 ? {} : _meta;
    var missingConceptText = meta.missingConceptText, metaTitle = meta.title, description = meta.description, ctaText = meta.ctaText;
    var _children = topicInfo.children, children = _children === void 0 ? [] : _children, title = topicInfo.title, areNotesEnabled = topicInfo.areNotesEnabled, _topicGroup = topicInfo.topicGroup, topicGroup = _topicGroup === void 0 ? [] : _topicGroup, hasNotes = topicInfo.hasNotes, author = topicInfo.author;
    var ref1 = topicGroup[0] || {}, tmp1 = ref1.title, topicGroupTitle = tmp1 === void 0 ? title : tmp1;
    var color = (0,getTopicGroupAssetObj/* default */.Z)(topicGroupTitle).color;
    var isSubscribed = (0,es/* useSelector */.v9)((0,subscription/* getIsSubscribedToGoal */.pN)(goalUID));
    var isLoggedIn = (0,es/* useSelector */.v9)(auth/* getIsLoggedIn */.M7);
    var isMobile = (0,AppCommonData/* useIsMobile */.dD)();
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), disable = ref2[0], setDisable = ref2[1];
    var showNotes = areNotesEnabled && hasNotes;
    var isSyllabusPageEducatorSpecific = getIsSyllabusPageEducatorSpecific(educatorUID, author);
    var showMissingChaptersNudge = isSyllabusPageEducatorSpecific && getIsChapterMissing(children);
    var handleGetSubscription = function() {
        (0,pushRoute/* default */.Z)("/goal/[goalSlug]/[goalUID]/subscribe", "/goal/".concat(goalSlug, "/").concat(goalUID, "/subscribe"));
    };
    // Enrollments Section
    var topicTopology = (0,es/* useSelector */.v9)(function(state) {
        return(// @ts-ignore
        (0,syllabus/* getTopicInfoForCoursesPage */.$Z)(state, topicUID));
    });
    var feedBlock = (0,es/* useSelector */.v9)(function(state) {
        return (0,syllabus/* getEnrolledCoursesFeed */.Lg)(state, topicTopology.uid);
    });
    // More Courses Section
    var noFiltersKey = (0,syllabusHelper/* getNoFiltersKey */.X)(topicTopology.uid);
    var moreCoursesAllFeed = (0,es/* useSelector */.v9)(function(state) {
        return (0,syllabus/* getMoreCoursesFeed */.by)(state, noFiltersKey);
    });
    var areMoreCoursesAvailable = moreCoursesAllFeed.results.length > 0 || moreCoursesAllFeed.isFetching;
    var scrollToCourses = function() {
        var ref;
        window.scrollTo({
            top: ((ref = coursesRef.current) === null || ref === void 0 ? void 0 : ref.offsetTop) - (HEADER_HEIGHT + MORE_COURSES_MARGIN_TOP),
            behavior: "smooth"
        });
    };
    var getHeightOfPreviousChildren = function(currentChild) {
        var children = Array.from(chaptersRef.current.children);
        var height = 0;
        (0,_to_consumable_array/* default */.Z)(Array(currentChild).keys()).forEach(function(element) {
            height += children[element].clientHeight + CHAPTERS_WRAPPER_MARGIN_BOTTOM;
        });
        return height;
    };
    var scrollToChapter = function(i) {
        window.scrollTo({
            top: getHeightOfPreviousChildren(i) + HEADER_HEIGHT,
            behavior: "smooth"
        });
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            dispatch((0,practiceSession/* fetchPracticeAvailableLanguages */.bc)(goalUID));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        if (isError) (0,route/* redirectToRoute */.i)(false, "", "/404", "/404");
    }, [
        isError
    ]);
    if (isError) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopicPage_Wrapper, {
        // @ts-ignore
        disabled: disable,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicPage_Header, {
                goalUID: goalUID,
                title: title,
                addMargin: children.length === 0,
                topicGroupTitle: topicGroupTitle,
                author: author
            }),
            children.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ChaptersInfo, {
                children: [
                    !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicPage_SideNav, {
                        chaptersList: children,
                        goalUID: goalUID,
                        areMoreCoursesAvailable: areMoreCoursesAvailable,
                        scrollToCourses: scrollToCourses,
                        scrollToChapter: scrollToChapter,
                        isSyllabusPageEducatorSpecific: isSyllabusPageEducatorSpecific
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Concepts, {
                        children: [
                            (!isLoggedIn || !isSubscribed) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicPage_PreSubscriptionBanner, {
                                title: "Get access to all videos",
                                description: "Get 800+hrs of full syllabus lectures with subscription",
                                handleButtonClick: handleGetSubscription
                            }),
                            showNotes && !isSyllabusPageEducatorSpecific && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NotesCard/* default */.Z, {
                                marginBottom: styleConstants/* Spacings.SPACING_6B */.t8.BY
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                ref: chaptersRef,
                                children: children.map(function(chapter, index) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChaptersWrapper, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChapterInfo/* default */.Z, {
                                            info: chapter,
                                            index: index + 1,
                                            showNotes: !areNotesEnabled,
                                            topicTitle: title,
                                            topicUID: topicUID,
                                            goalUID: goalUID,
                                            color: color,
                                            disableTopicPage: setDisable,
                                            missingConceptText: missingConceptText,
                                            isSyllabusPageEducatorSpecific: isSyllabusPageEducatorSpecific
                                        })
                                    }, chapter.uid);
                                })
                            }),
                            showMissingChaptersNudge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicPage_MissingChaptersNudge, {
                                meta: meta
                            })
                        ]
                    })
                ]
            }),
            !isSyllabusPageEducatorSpecific && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(enrollments_EnrolledCourses, {
                topic: topicTopology,
                ref: coursesRef
            }),
            areMoreCoursesAvailable && !isSyllabusPageEducatorSpecific && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MoreCoursesWrapper, {
                ref: !feedBlock.results.length ? coursesRef : null,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicPage_Title, {
                        as: "h2",
                        children: "More courses"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoreCourses/* default */.Z, {
                        // @ts-ignore
                        topic: topicTopology,
                        isContentAvailable: false,
                        goalUID: goalUID,
                        gridNumber: 24,
                        lastPrimarySource: segment/* TOPIC_SYLLABUS_PAGE */.zyj,
                        lastPrimarySourceSection: "Topic Page - More Courses"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var TopicPage_TopicPage = (TopicPage);

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/utils/setupInitialProps.js
var setupInitialProps = __webpack_require__(57714);
// EXTERNAL MODULE: ./src/layout/index.jsx + 26 modules
var layout = __webpack_require__(41566);
// EXTERNAL MODULE: ./src/api/fetchers/constants.js
var fetchers_constants = __webpack_require__(59262);
// EXTERNAL MODULE: ./src/utils/escapeHTML.js
var escapeHTML = __webpack_require__(4297);
// EXTERNAL MODULE: ./src/components/Container/App/PageReduxProviderWrapper.jsx
var PageReduxProviderWrapper = __webpack_require__(27300);
// EXTERNAL MODULE: ./src/models/Me.js + 4 modules
var Me = __webpack_require__(92942);
;// CONCATENATED MODULE: ./src/pages/goal/[goalSlug]/[goalUID]/topic/[topicUid]/[conceptUid].jsx




/* eslint-disable react/forbid-prop-types */ 




















var PlusConceptPage = function(param) {
    var goalInfo = param.goalInfo, topicInfo = param.topicInfo, topicUID = param.topicUID, fallback = param.fallback;
    var ref = goalInfo || {}, goalName = ref.name, goalSlug = ref.goalSlug, goalUID = ref.uid, goalThumbnail = ref.thumbnail;
    var ref1 = topicInfo || {}, topicName = ref1.name, topicSlug = ref1.slug, topicThumbnail = ref1.thumbnail, _parent = ref1.parent, parent = _parent === void 0 ? {} : _parent;
    var metaTitle = "".concat(goalName, " ").concat(topicName, " - Prepare with Unacademy");
    var metaDescription = "Enroll for ".concat(goalName, " ").concat(topicName, " Course on Unacademy and learn\n  from Top Educators. Subscribe today and get access to complete syllabus and course.");
    var canonicalURL = "https://unacademy.com/goal/".concat(goalSlug, "/").concat(goalUID, "/topic/").concat(topicSlug, "/").concat(topicUID);
    (0,sidenav/* useSetSelectedNav */.WF)("topics");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(seo/* default */.Z, {
                title: metaTitle,
                description: metaDescription,
                openGraph: {
                    title: metaTitle,
                    description: metaDescription,
                    images: [
                        {
                            url: topicThumbnail || goalThumbnail
                        }
                    ],
                    url: canonicalURL
                },
                schema: (0,topic/* default */.Z)({
                    goal: goalInfo,
                    topic: {
                        name: parent.name,
                        permalink: "https://unacademy.com/goal/".concat(goalSlug, "/").concat(goalUID, "/topic/").concat(topicSlug, "/")
                    },
                    others: [
                        {
                            name: topicName,
                            permalink: canonicalURL
                        }
                    ],
                    type: "courses",
                    topicInfo: topicInfo,
                    description: metaDescription
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                    children: metaTitle
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* SWRConfig */.J$, {
                value: {
                    fallback: fallback
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TopicPage_TopicPage, {
                    goalUID: goalUID,
                    goalSlug: goalSlug,
                    topicUID: topicUID
                })
            })
        ]
    });
};
PlusConceptPage.pageInfo = {
    isMWebSupported: true,
    name: "Syllabus Topic Chapters Page",
    layoutOptions: {
        showPlusNav: false
    }
};
/* harmony default export */ var _conceptUid_ = (PlusConceptPage);
PlusConceptPage.getInitialProps = (0,setupInitialProps/* default */.Z)(function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
        var store, query, isServer, res, goalUID, goalSlug, topicGroupUID, topicUID, educatorUID, educatorUsername, state, dispatch, getState, isLoggedIn, isSubscribed, isOfflineSubscribed, meData, isPlusUser, isGTP, promises, isNewSyllabusEnabled, topicInfoEndpoint, fallback, syllabusTopicpageInfo;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    store = param.store, query = param.query, isServer = param.isServer, res = param.res;
                    goalUID = query.goalUID, goalSlug = query.goalSlug, topicGroupUID = query.topicUid, topicUID = query.conceptUid, educatorUID = query.educatorUID, educatorUsername = query.educatorUsername;
                    state = store.getState();
                    dispatch = store.dispatch, getState = store.getState;
                    isLoggedIn = (0,auth/* getIsLoggedIn */.M7)(state);
                    isSubscribed = (0,subscription/* getIsSubscribedToPlus */.FZ)(goalUID)(state);
                    isOfflineSubscribed = (0,subscription/* getIsSubscribedToOffline */.ZB)(goalUID)(state);
                    meData = (0,auth/* getMe */.jo)(state);
                    isPlusUser = (0,Me/* hasActiveSubscriptionToGoal */.Bx)(meData, goalUID);
                    _ctx.next = 11;
                    return (0,fetchers_constants/* default */.ZP)(goalUID, store);
                case 11:
                    isGTP = _ctx.sent;
                    // Educator Library is Enabled
                    if (educatorUID && (!isLoggedIn || !(isSubscribed || isOfflineSubscribed))) {
                        if (educatorUsername) {
                            (0,route/* redirectToRoute */.i)(isServer, res, "/@".concat(educatorUsername));
                        } else {
                            (0,route/* redirectToRoute */.i)(isServer, res, "/goal/".concat(goalSlug, "/").concat(goalUID, "/topic/").concat(topicGroupUID, "/").concat(topicUID));
                        }
                    }
                    if (!(!isPlusUser && isGTP)) {
                        _ctx.next = 15;
                        break;
                    }
                    return _ctx.abrupt("return", (0,route/* redirectToRoute */.i)(isServer, res, "/goal/".concat(goalSlug, "/").concat(goalUID)));
                case 15:
                    if (!(goalUID && topicUID)) {
                        _ctx.next = 24;
                        break;
                    }
                    promises = [];
                    if (!(0,selectors_topologies/* getIsTopologySelfDataFetched */.xr)(state, goalUID)) promises.push(store.dispatch((0,topologies/* fetchTopologyInfo */.Yn)(goalUID)));
                    if (!(0,selectors_topologies/* getIsTopologySelfDataFetched */.xr)(state, topicUID)) promises.push(store.dispatch((0,topologies/* fetchTopologyInfo */.Yn)(topicUID)));
                    if (isLoggedIn && (isSubscribed || isOfflineSubscribed)) {
                        promises.push(store.dispatch((0,courses/* fetchTopologyEnrolledCourses */.hU)(topicUID, false, false, "", 5)));
                    }
                    promises.push(store.dispatch((0,courses/* fetchMoreCoursesFilters */.vn)(goalUID)));
                    promises.push(store.dispatch((0,courses/* fetchMoreCourses */.Gy)({
                        topicUid: topicUID,
                        key: (0,syllabusHelper/* getNoFiltersKey */.X)(topicUID)
                    })));
                    _ctx.next = 24;
                    return Promise.all(promises);
                case 24:
                    state = store.getState();
                    isNewSyllabusEnabled = (0,selectors_topologies/* getIsSyllabusV1Enabled */.xm)(state, goalUID);
                    topicInfoEndpoint = (0,apiHelper/* getTopicInfoEndpoint */.PC)(goalUID, topicUID, educatorUID);
                    if (!isNewSyllabusEnabled) {
                        (0,route/* redirectToRoute */.i)(isServer, res, "/goal/".concat(goalSlug, "/").concat(goalUID, "/topic/").concat(topicUID, "/courses"));
                    }
                    fallback = {};
                    if (!(goalUID && topicUID && isNewSyllabusEnabled)) {
                        _ctx.next = 34;
                        break;
                    }
                    _ctx.next = 32;
                    return (0,apiHelper/* apiFetcher */.h6)(topicInfoEndpoint, {
                        dispatch: dispatch,
                        getState: getState
                    });
                case 32:
                    syllabusTopicpageInfo = _ctx.sent;
                    fallback = (0,_define_property/* default */.Z)({}, topicInfoEndpoint, syllabusTopicpageInfo);
                case 34:
                    state = store.getState();
                    return _ctx.abrupt("return", {
                        fallback: fallback,
                        topicUID: (0,escapeHTML/* default */.Z)(topicUID),
                        goalInfo: state.topologies.data[goalUID],
                        topicInfo: state.topologies.data[topicUID]
                    });
                case 36:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(_) {
        return _ref.apply(this, arguments);
    };
}(), PlusConceptPage.pageInfo);
PlusConceptPage.propTypes = {
    goalInfo: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    topicInfo: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    topicUID: (prop_types_default()).string.isRequired,
    fallback: prop_types_default().shape((0,_define_property/* default */.Z)({}, (prop_types_default()).string, (prop_types_default()).any)).isRequired
};
PlusConceptPage.Layout = layout/* default */.Z;
PlusConceptPage.Wrapper = PageReduxProviderWrapper["default"];


/***/ }),

/***/ 10448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ki": function() { return /* binding */ getCompletedCoursesFeed; },
  "mt": function() { return /* binding */ getCurrentMoreCoursesFeed; },
  "Lg": function() { return /* binding */ getEnrolledCoursesFeed; },
  "eU": function() { return /* binding */ getGoalInfoForCoursesPage; },
  "wE": function() { return /* binding */ getIsTopologyFeedLoaded; },
  "by": function() { return /* binding */ getMoreCoursesFeed; },
  "I_": function() { return /* binding */ getMoreCoursesFilters; },
  "QQ": function() { return /* binding */ getRecommendedCourses; },
  "uR": function() { return /* binding */ getTopicFeedRowData; },
  "$Z": function() { return /* binding */ getTopicInfoForCoursesPage; },
  "dM": function() { return /* binding */ getTopologyFeed; },
  "b": function() { return /* binding */ getTopologyInfo; },
  "D9": function() { return /* binding */ hasCompletedCourses; },
  "N4": function() { return /* binding */ hasEnrolledCourses; },
  "_Z": function() { return /* binding */ hasRecommendedCourses; }
});

// UNUSED EXPORTS: getTopologyFeedResults

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/reselect/es/index.js + 1 modules
var es = __webpack_require__(68697);
// EXTERNAL MODULE: ./src/utils/feedTypeHelper.js
var feedTypeHelper = __webpack_require__(99682);
// EXTERNAL MODULE: ./src/constants/empty.js
var empty = __webpack_require__(59375);
// EXTERNAL MODULE: ./src/redux/selectors/topologies.js
var topologies = __webpack_require__(83109);
;// CONCATENATED MODULE: ./src/redux/selectors/feedrows.js
// feedRowUID - uid from FeedRow model
var emptyExtraBlockInfoObject = {
    entity_type: "",
    data: [],
    id: ""
};
var emptyFeedRowObject = {
    extraBlockinfo: emptyExtraBlockInfoObject
};
// eslint-disable-next-line import/prefer-default-export
var getFeedRow = function(state, feedRowUID) {
    return state.feedrows.data[feedRowUID] || emptyFeedRowObject;
};

;// CONCATENATED MODULE: ./src/redux/selectors/syllabus.js







var getUid = function(_, uid) {
    return uid;
};
var topologyUidAndName = {
    uid: getUid,
    name: topologies/* getTopologyName */.yb
};
var topologyBasicInfo = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, topologyUidAndName), {
    isNoTestGoal: topologies/* getIsNoTestGoal */.NF,
    slug: topologies/* getTopologySlug */.OQ
});
/**
 * @param {Object} state - Entire store object
 * @param {String} topologyUID - uid of the required topology
 * @returns {Object} {uid, name, coursesCount, upcomingCoursesThisMonth, isNoTestGoal, slug}
 */ var getTopologyInfo = (0,es/* createStructuredSelector */.zB)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, topologyBasicInfo), {
    coursesCount: topologies/* getTopologyCoursesCount */.Cl,
    upcomingCoursesThisMonth: topologies/* getTopologyUpcomingCoursesCountThisMonth */.x4
}));
var getTopologyFeed = function(state, topologyUID) {
    return state.paginator.topologyFeed[topologyUID];
};
var getTopologyFeedOrEmptyObject = function(state, topologyUID) {
    return getTopologyFeed(state, topologyUID) || empty/* emptyPaginatedObject */.vs;
};
var getIsTopologyFeedLoaded = function(state, topologyUID) {
    return getTopologyFeedOrEmptyObject(state, topologyUID).loaded;
};
var getTopologyFeedResults = function(state, topologyUID) {
    return getTopologyFeedOrEmptyObject(state, topologyUID).results;
};
var getTopicFeedRowData = function(state, topologyUID) {
    var topicFeedRow = getTopologyFeedResults(state, topologyUID).map(function(item) {
        return getFeedRow(state, item.feedrow);
    }).find(function(feedRow) {
        return (0,feedTypeHelper/* isTopicFeed */.BK)((feedRow.extraBlockinfo || emptyExtraBlockInfoObject).entity_type) && feedRow.type !== "topic_group_non_feed";
    });
    if (topicFeedRow) return topicFeedRow.data;
    return [];
};
// #region courses-page-selectors
var getGoalInfoForCoursesPage = (0,es/* createStructuredSelector */.zB)(topologyBasicInfo);
var getParentUidAndName = (0,es/* createStructuredSelector */.zB)({
    uid: getUid,
    name: topologies/* getTopologyParentName */.vo
});
var getTopicInfoForCoursesPage = (0,es/* createStructuredSelector */.zB)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, topologyUidAndName), {
    parent: getParentUidAndName
}));
var getEnrolledCoursesFeed = function(state, topologyUID) {
    return state.paginator.enrolledCourses[topologyUID] || empty/* emptyPaginatedObject */.vs;
};
var getEnrolledCourses = function(state, topologyUID) {
    return getEnrolledCoursesFeed(state, topologyUID).results;
};
var hasEnrolledCourses = function(state, topologyUID) {
    return getEnrolledCourses(state, topologyUID).length > 0;
};
var getRecommendedCoursesFeed = function(state, topologyUID) {
    return state.paginator.recommendedCourses[topologyUID] || empty/* emptyPaginatedObject */.vs;
};
var getRecommendedCourses = function(state, topologyUID) {
    return getRecommendedCoursesFeed(state, topologyUID).results;
};
var hasRecommendedCourses = function(state, topologyUID) {
    return getRecommendedCourses(state, topologyUID).length > 0;
};
var getCompletedCoursesFeed = function(state, topologyUID) {
    return state.paginator.completedCourses[topologyUID] || empty/* emptyPaginatedObject */.vs;
};
var getCompletedCourses = function(state, topologyUID) {
    return getCompletedCoursesFeed(state, topologyUID).results;
};
var hasCompletedCourses = function(state, topologyUID) {
    return getCompletedCourses(state, topologyUID).length > 0;
};
var getMoreCoursesFilters = function(state, goalUID) {
    return state.courses.moreCoursesFilters[goalUID] || empty/* emptyObject */.FD;
};
var getMoreCoursesFeed = function(state, key) {
    return state.paginator.moreCourses[key] || empty/* emptyPaginatedObject */.vs;
};
var getPreviousMoreCoursesFeed = function(state, key, previousKey) {
    var newFeed = getMoreCoursesFeed(state, key);
    var previousFeed = getMoreCoursesFeed(state, previousKey);
    return !newFeed.loaded || newFeed.isFetching ? previousFeed : null;
};
var getCurrentMoreCoursesFeed = function(state, key, previousKey, areFiltersChanged) {
    var moreCoursesFeed = getMoreCoursesFeed(state, key);
    var prevMoreCoursesFeed = getPreviousMoreCoursesFeed(state, key, previousKey);
    return (!moreCoursesFeed.loaded || moreCoursesFeed.isFetching) && areFiltersChanged ? prevMoreCoursesFeed : moreCoursesFeed;
}; // #endregion


/***/ }),

/***/ 29630:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var breadCrumbSchema = function(breads) {
    var schema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList"
    };
    schema.itemListElement = breads.filter(function(bread) {
        return bread.name && bread.url;
    }).map(function(bread, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            name: bread.name,
            item: bread.url
        };
    });
    return schema;
};
/* harmony default export */ __webpack_exports__["Z"] = (breadCrumbSchema);


/***/ }),

/***/ 84028:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var subListing = function(course) {
    var topic = course.topic, name = course.name, forPlus = course.forPlus, description = course.description, link = course.link;
    return [
        {
            hasCourseInstance: {
                "@type": "CourseInstance",
                courseMode: "Online"
            },
            "@id": link,
            about: {
                name: topic
            },
            "@context": "http://schema.org",
            isAccessibleForFree: forPlus ? "http://schema.org/False" : "http://schema.org/True",
            name: name,
            provider: {
                "@type": "Organization",
                name: "Unacademy"
            },
            "@type": "Course",
            description: description
        }
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (subListing);


/***/ }),

/***/ 23018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hm": function() { return /* binding */ goBack; },
/* harmony export */   "Ox": function() { return /* binding */ getDoubtSolutionsHomeTags; },
/* harmony export */   "ZM": function() { return /* binding */ getFreeCourseTags; },
/* harmony export */   "fu": function() { return /* binding */ getCatalogueQuetionsHomeTag; },
/* harmony export */   "ll": function() { return /* binding */ getClass; },
/* harmony export */   "rs": function() { return /* binding */ getCatalogueDetailsHomeTags; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _models_Topology__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34482);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56046);
/* harmony import */ var _api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61059);
/* harmony import */ var _layout_NavBar_PlusNavBar_plusNavBarItems__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2990);
/* harmony import */ var _textHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31309);

/* eslint-disable max-lines */ 




var getClass = function() {
    var item = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, isGTP = arguments.length > 1 ? arguments[1] : void 0;
    var ref;
    var _programme = item.programme, programme = _programme === void 0 ? {} : _programme;
    var goal = programme.goal, courseName = programme.name;
    if (!goal) return [];
    if (item.isSpecial || ((ref = item.programme) === null || ref === void 0 ? void 0 : ref.isSpecial)) {
        var tags = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
            }
        ];
        tags.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : {
            title: "Free classes & tests",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLink */ .Lb)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesLinkHref */ .EN)()
        });
        return tags.map(function(tag) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, tag, tag.as && {
                url: tag.as
            });
        });
    }
    var tags1 = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (!isGTP) {
        tags1.push({
            title: courseName,
            as: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLink */ .Rg)(programme),
            href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_1__/* .getLinkPath */ .bc)(programme)
        });
    }
    return tags1.map(function(tag) {
        return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, tag, tag.as && {
            url: tag.as
        });
    });
};
var getDoubtSolutionsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getCatalogueQuetionsHomeTag = function(goal, ctlgData) {
    var // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var ctlgSlug = ctlgData.ctlgSlug, ctlgUID = ctlgData.ctlgUID, ctlgTitle = ctlgData.ctlgTitle;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubt Solving",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        },
        {
            title: ctlgTitle,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/").concat(ctlgSlug, "/").concat(ctlgUID),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/[catalogSlug]/[catalogUID]")
        }
    ];
};
var getCatalogueDetailsHomeTags = function(goal) {
    var // eslint-disable-next-line no-unused-vars
    ctlgData = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, // eslint-disable-next-line no-unused-vars
    ctlgItemData = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, isOfflineSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Doubts & solutions",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/doubts-and-solutions/"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/doubts-and-solutions/")
        }
    ];
};
var getPlusTopicsTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getPlatformBatchTopicsTags = function(goal) {
    if (!goal) return [];
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
};
var getBatchTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, isStoreRoute = arguments.length > 2 ? arguments[2] : void 0;
    if (!goal) return;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return isStoreRoute ? [
        {
            title: goal.name,
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        },
        {
            title: "Batches",
            as: "".concat(as, "/store"),
            href: "".concat(href, "/store")
        }
    ] : [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: title,
            as: as,
            href: href
        },
        {
            title: "Batches",
            as: "".concat(as, "/batches"),
            href: "".concat(href, "/batches")
        }
    ];
};
var getYoutubeLessonTags = function(goal, data) {
    if (!goal) return;
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: goal.name
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)(data)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: data.playlistName
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeLessonLink */ ._Y)(data))
    ];
};
var getYoutubeCourseTags = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal)),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)())
        },
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: "Free courses"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getYoutubeCourseLink */ .bU)({
            goalUID: goal.uid
        }))
    ];
};
var getGoalAndFreeTagsOfFreeTopic = function(goal) {
    if (!goal) return;
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Free courses",
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/free-platform"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/free-platform")
        }
    ];
};
var getGoalTopicsTitle = function(goal, isGTP) {
    if (goal.isNoTestGoal) return "Key concepts";
    if (isGTP) return "Video lessons";
    return _layout_NavBar_PlusNavBar_plusNavBarItems__WEBPACK_IMPORTED_MODULE_3__/* ["default"].PLAYLIST */ .Z.PLAYLIST;
};
var getTopics = function(goal) {
    var isGTP = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (!goal) return;
    return [
        {
            // eslint-disable-next-line no-nested-ternary
            title: getGoalTopicsTitle(goal, isGTP),
            as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/topics"),
            href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/topics")
        }
    ];
};
var getTopologyTags = function(topology, goal) {
    if (!topology || !goal) return;
    return [
        {
            title: topology.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topology, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLinkHref */ .BR)()
        }
    ];
};
var getEducatorTag = function(author, educatorUsername) {
    if (!author) return;
    return [
        {
            title: (0,_api_hooks_utils__WEBPACK_IMPORTED_MODULE_2__/* .getFullName */ .P)(author.firstName, author.lastName),
            as: "/@".concat(educatorUsername),
            href: "/[authorID]"
        }
    ];
};
var getCourseTags = function(goal, topicGroup) {
    var isOfflineSubscription = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var Tags = [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        }
    ];
    if (topicGroup) {
        Tags.push({
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        }, {
            title: topicGroup.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        });
    }
    return Tags;
};
var getFreeCourseTags = function(goal, topologies) {
    var ref;
    if (!(goal === null || goal === void 0 ? void 0 : goal.uid)) return [];
    var ref1 = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal), href = ref1.href, as = ref1.as;
    var Tags = [
        {
            title: goal.name,
            href: href,
            as: as
        },
        {
            title: "Free courses",
            href: href,
            as: as
        }
    ];
    if (topologies === null || topologies === void 0 ? void 0 : (ref = topologies.parent) === null || ref === void 0 ? void 0 : ref.parent) {
        Tags.push({
            title: topologies.parent.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_4__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID] "
        });
        Tags.push({
            title: topologies.parent.name,
            as: "/goal/".concat(goal.goalSlug, "/").concat(goal.uid, "/free-platform/").concat(topologies.parent.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_4__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.parent.name, "-"), "/").concat(topologies.parent.slug || (0,_textHelper__WEBPACK_IMPORTED_MODULE_4__/* .getStringWordsJoinedWith */ .kL)(topologies.parent.name, "-"), "/").concat(topologies.parent.uid),
            href: "/goal/[goalSlug]/[goalUID]/free-platform/[topicSlugType]/[topicSlugUID]/[conceptUID] "
        });
    }
    return Tags;
};
var getTestSeriesTags = function(goal) {
    var isOfflineSubscription = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    if (!goal) return [];
    var title = isOfflineSubscription ? "Centre" : "Plus";
    return [
        {
            title: goal.name,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: title,
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)()
        },
        {
            title: "Test series",
            href: "/goal/[goalSlug]/[goalUID]/test-series",
            as: "/goal/".concat(goal.slug, "/").concat(goal.uid, "/test-series")
        }
    ];
};
var getPlatformSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isOfflineSubscription = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null;
    var seeAllLinks = null;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: "Free classes & tests"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    return [
        {
            title: goal.name
        },
        {
            title: title
        },
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSeeAllTags = function(seeAllType, goal, topicGroup) {
    var hasSubscription = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, pageType = arguments.length > 4 ? arguments[4] : void 0, isGTP = arguments.length > 5 ? arguments[5] : void 0, isOfflineSubscription = arguments.length > 6 ? arguments[6] : void 0;
    var title = isOfflineSubscription ? "Centre" : "Plus";
    var seeAllLinks = null;
    if (seeAllType === "enrolledBatches") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: goal.name
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getPannerLink */ .vx)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "specialClass") {
        seeAllLinks = [
            {
                title: goal.name,
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            }
        ];
        seeAllLinks.push(isGTP ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: "Free Classes"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getGtpFreeClassesAllLink */ .v9)(goal)) : (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: "Free classes & tests"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getSpecialClassesAllLink */ .Po)(goal)));
        return seeAllLinks;
    }
    if (seeAllType === "goal" && !hasSubscription) {
        if ([
            "educators",
            "batches",
            "upcoming",
            "recently_started",
            "popular_courses"
        ].includes(pageType)) {
            seeAllLinks = [
                {
                    title: goal.name,
                    as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                    href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
                },
                {
                    title: "Browse",
                    as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/browse"),
                    href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal), "/browse")
                }
            ];
            return seeAllLinks;
        }
    }
    if (seeAllType === "goal" || seeAllType === "enrolled") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "freeCourses") {
        seeAllLinks = [
            {
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || "",
                as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal),
                href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(goal)
            },
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: "Free"
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfAFreeCourse */ .Ho)(goal))
        ];
        return seeAllLinks;
    }
    if (seeAllType === "enrolledCourses") {
        seeAllLinks = [
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                title: title
            }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
            {
                title: "Enrolled",
                href: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)(), "/enrolled"),
                as: "".concat((0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal), "/enrolled")
            }
        ];
        return seeAllLinks;
    }
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: (goal === null || goal === void 0 ? void 0 : goal.name) || ""
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: title
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getBrowseLink */ .UP)(goal)),
        {
            title: "Syllabus",
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListLink */ .dF)(goal),
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicListHref */ .s3)()
        },
        {
            title: topicGroup.name,
            href: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getTopicLink */ .pA)(topicGroup, goal),
            as: (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkPath */ .bc)()
        }
    ];
};
var getSavedTag = function(goal) {
    if (!goal) return [];
    return [
        (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
            title: "Saved"
        }, (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getHrefAndAsOfSaved */ .vX)(goal))
    ];
};
var goBack = function() {
    return window.history.back();
};
var getDriveTags = function(ancestors) {
    if (!ancestors || !Array.isArray(ancestors)) return [];
    return ancestors.map(function(item) {
        var isRoot = (item === null || item === void 0 ? void 0 : item.name) === "root";
        return {
            title: isRoot ? "Cloud" : item === null || item === void 0 ? void 0 : item.name,
            as: isRoot ? "/educator/drive" : "/educator/drive/folder/".concat(item === null || item === void 0 ? void 0 : item.uid),
            href: isRoot ? "/educator/drive" : "/educator/drive/folder/[itemUID]"
        };
    });
};
var getFreeLiveClassesTags = function(goal) {
    if (!goal) return;
    var as = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLink */ .Rg)(goal);
    var href = (0,_models_Topology__WEBPACK_IMPORTED_MODULE_0__/* .getLinkHref */ .Hw)();
    return [
        {
            title: goal.name,
            as: as,
            href: href
        },
        {
            title: "Free live classes",
            as: "".concat(as, "/classes"),
            href: "".concat(href, "/classes")
        }
    ];
};
var breadcrumbs = {
    getClass: getClass,
    goBack: goBack,
    getPlusTopicsTags: getPlusTopicsTags,
    getTopologyTags: getTopologyTags,
    getTopics: getTopics,
    getCourseTags: getCourseTags,
    getTestSeriesTags: getTestSeriesTags,
    getSeeAllTags: getSeeAllTags,
    getFreeCourseTags: getFreeCourseTags,
    getGoalAndFreeTagsOfFreeTopic: getGoalAndFreeTagsOfFreeTopic,
    getBatchTags: getBatchTags,
    getSavedTag: getSavedTag,
    getDriveTags: getDriveTags,
    getDoubtSolutionsHomeTags: getDoubtSolutionsHomeTags,
    getCatalogueQuetionsHomeTag: getCatalogueQuetionsHomeTag,
    getCatalogueDetailsHomeTags: getCatalogueDetailsHomeTags,
    getPlatformSeeAllTags: getPlatformSeeAllTags,
    getPlatformBatchTopicsTags: getPlatformBatchTopicsTags,
    getEducatorTag: getEducatorTag,
    getYoutubeLessonTags: getYoutubeLessonTags,
    getYoutubeCourseTags: getYoutubeCourseTags,
    getFreeLiveClassesTags: getFreeLiveClassesTags
};
/* harmony default export */ __webpack_exports__["ZP"] = (breadcrumbs);


/***/ }),

/***/ 4297:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var escape = function(string) {
    return (string || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;").replace(/\u200b/g, "").replace(/â€‹/g, "");
};
/* harmony default export */ __webpack_exports__["Z"] = (escape);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [35303,86924,82492,52420,25675,96523,61608,41664,63953,74635,64097,21322,84872,55169,23329,61149,9720,46571,89374,94336,4392,72047,56015,41566,32410,48392,77566,94774,85997,49774,92888,40179], function() { return __webpack_exec__(57618); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);